<template>
    <app-page-content>
        <app-sub-title text="Indicadores de Operación" />
        <div class="d-print-none">
            <app-autocomplete
                :items="clients"
                v-model="clientId"
                :get-object="false"
            ></app-autocomplete>
        </div>
        <app-dashboard-report
            v-if="!!selectedClient"
            :selected-client="selectedClient"
        />
    </app-page-content>
</template>
<script>
import DashboardReport from '../../Client/Dashboard/DashboardReport/DashboardReport.vue'
import { mapGetters } from 'vuex'
export default {
    components: {
        appDashboardReport: DashboardReport,
    },
    data() {
        return {
            clientId: '',
        }
    },
    computed: {
        ...mapGetters(['clients']),
        selectedClient() {
            if (!this.clientId) return null
            return this.clients.find(item => item.id === this.clientId)
        },
    },
    mounted() {
        this.load('clients')
    },
}
</script>
